import { modalOverrides, sponsorModal, textModal } from "./common"

export default [
    {
        width: "5.2%",
        height: "11.1%",
        left: "78.5%",
        top: "24.3%",
        label: "Algosec - Contact us",
        isExternal: true,
        onClick: () => {
            document.getElementById("Algosec").click()
        }
    },
    {
        width: "3.6%",
        height: "9.2%",
        left: "87.8%",
        top: "23.8%",
        label: "Algosec - Executive Sumary",
        isExternal: true,
        target: "_blank",
        href: "https://assets.swoogo.com/uploads/2162192-635c1362c5034.pdf"
    },
    {
        width: "6.6%",
        height: "6.6%",
        left: "86.4%",
        top: "15.6%",
        label: "Algosec Play Content",
        isExternal: true,
        modalOverrides,
        modal: <div style={{height: "100%", width: "100%"}}>
            <iframe width="100%" height="100%" frameBorder="0"  src="https://player.vimeo.com/video/764601151?h=cd93f27e78&autoplay=1" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen autoplay/>
        </div>
    },
    {
        width: "8.6%",
        height: "5.6%",
        left: "85.4%",
        top: "9.6%",
        label: "Algosec - Social Media",
        isExternal: true,
        modalOverrides: textModal(),
        modal: sponsorModal("Booth 3", "Algosec", 
        <>
            AlgoSec, a global cybersecurity leader, empowers organisations to secure application connectivity by automating 
            connectivity flows and security policy, anywhere. The AlgoSec platform enables the world’s most complex 
            organisations to gain visibility, reduce risk and process changes at zero-touch across the hybrid network.  Over 
            1,800 of the world’s leading organisations trust AlgoSec to help secure their most critical workloads across public 
            cloud, private cloud, containers, and on-premises networks, while taking advantage of almost two decades of 
            leadership in Network Security Policy Management. See what securely accelerating your digital transformation, 
            move-to-cloud, infrastructure modernisation, or micro-segmentation initiatives look like at:
        </>, {
            twitter: "https://twitter.com/algosec",
            facebook: "https://www.facebook.com/AlgoSec",
            linkedin: "https://www.linkedin.com/company/algosec/",
            company: "https://www.algosec.com/"
        })
    }
]